import { Interpolation } from "@emotion/core";
import { grid } from "../../design-tokens/grid";
import { DarkTheme } from "../../design-tokens/media-queries";
import { Colors } from "../../design-tokens/colors";
import { Border } from "../../design-tokens/borders";

const root: Interpolation = {
  position: "relative",
  display: "flex",
  justifyContent: "flex-end",
};

const controlLabel: Interpolation = {
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  height: grid(4),
  fontSize: "14px",
  lineHeight: "20px",
  marginTop: grid(-1),
  marginBottom: grid(-1),
};

const sortValue: Interpolation = {
  color: Colors.Blue,

  [DarkTheme]: {
    color: Colors.DarkModeTextBlue,
  },
};

const controlIcon: Interpolation = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: grid(1.5),
  marginLeft: grid(0.5),
  transition: "transform 0.2s ease",
};

const dropdownBox: Interpolation = {
  position: "absolute",
  top: grid(4),
  right: 0,
  backgroundColor: Colors.White,
  borderRadius: Border.RadiusSm,
  boxShadow: `0 5px 20px 0 rgba(0, 0, 0, 0.3)`,
  zIndex: 10,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },
};

const listItem: Interpolation = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  height: grid(4),
  fontSize: "14px",
  whiteSpace: "nowrap",
  padding: `0 ${grid(2)}`,
  cursor: "pointer",
};

const styles = {
  root,
  controlLabel,
  sortValue,
  controlIcon,
  dropdownBox,
  listItem,
};

export default styles;
